// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"FooterNav__materialize-textarea___3jGrj","modal-2463794813":"FooterNav__modal-2463794813___1VpqG","container":"FooterNav__container___1Rot3","navContainer":"FooterNav__navContainer___3s-yR","buttonContainer":"FooterNav__buttonContainer___NJbET"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterNav/FooterNav.scss
// module id = 1492
// module chunks = 0